export default "__VITE_ASSET__CHInAo2O__"